import * as React from 'react';
import styled from "styled-components";
import {Background, Overlay} from "../styled-components/Overlay";
import I18n from '../utils/i18n';
import {WP_CONTENT_PREFIX, OPTION_PAGE, SCREENS} from "../constants";
import {CenterHorizontalWrapper} from "../styled-components/CenterWrapper";
import {analyticsEvent} from "../utils/analytics";

const Title = styled.div`
    font-family: 'Pixel Coleco';
    font-size: 4vh;
    text-align: center;
    color: #fed230;
    margin: 2vh 0 2vh 0;
`;

const Subtitle = styled.div`
    font-family: 'Pixel Coleco';
    font-size: ${props => props.bigger ? '3vh' : '2vh'};
    text-align: center;
    color: #ffffff;
    width: ${props => props.bigger ? '27vw' : '45vw'};
    margin-bottom: 1vh;
`;

const AboveCTAImage = styled.img`
    width: ${props => props.screen === SCREENS.first ? '11vw' : '18vw'};
    margin-top: 2vh;
`;

const CTAWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover div {
        background-color: #0e71c3;
    }
`

const CTASide = styled.div`
    width: 0.4vw;
    height: 6vh;
    box-shadow: inset 0 4px 0 0 rgba(255, 255, 255, 0.25);
    background-color: #0c80df;
`;

const CTAMiddle = styled.div`
    width: 19vw;
    height: 8vh;
    box-shadow: inset 0 4px 0 0 rgba(255, 255, 255, 0.25);
    font-family: 'Pixel Coleco';
    font-size: 2.7vh;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: #0c80df;
`;

const LeftCTA = styled.a`
    font-family: 'Pixel Coleco';
    font-size: 2vh;
    text-align: center;
    color: #0c80df;
    margin-right: 7vw;
    margin-top: 9vh;
    cursor: pointer;
`;

const RightCTA = styled.a`
    font-family: 'Pixel Coleco';
    font-size: 2vh;
    text-align: center;
    color: #0c80df;
    margin-top: 9vh;
    cursor: pointer;
`;

export class BounceOverlay extends React.Component {

    constructor() {
        super();
        this.onCTAClick = this.onCTAClick.bind(this);
        this.onTutorialClick = this.onTutorialClick.bind(this);
        this.onSettingsClick = this.onSettingsClick.bind(this);
    }

    onCTAClick() {
        const {screen, closeBounceOverlay} = this.props;
        analyticsEvent('Onboarding',
            `${screen === SCREENS.first ? 'Exit popup 1' : 'Exit popup 2'}`,
            `${screen === SCREENS.first ? 'Start' : 'Continue'}`,
            screen
        );
        closeBounceOverlay();
    }

    onTutorialClick() {
        const {screen} = this.props;
        analyticsEvent('Onboarding',
            `${screen === SCREENS.first ? 'Exit popup 1' : 'Exit popup 2'}`,
            'Tutorial',
            screen
        );
    }

    onSettingsClick() {
        const {screen} = this.props;
        analyticsEvent('Onboarding',
            `${screen === SCREENS.first ? 'Exit popup 1' : 'Exit popup 2'}`,
            'Settings',
            screen
        );
    }

    componentDidMount() {
        const {screen} = this.props;
        analyticsEvent('Onboarding',
            `${screen === SCREENS.first ? 'Exit popup 1' : 'Exit popup 2'}`,
            'Shown',
            screen
        );
    }

    render() {
        const {screen} = this.props;
        const TUTORIAL_VIDEO = 'https://www.youtube.com/watch?v=vls3se188NE';

        return (
            <Background>
                <Overlay padding="4vw">
                    <Title>{I18n.translate('firstExistPopuptitle')}</Title>
                    <Subtitle bigger={true}>{screen === SCREENS.first ? I18n.translate('firstExistPopupSubtitle') : I18n.translateWithPlaceholder('secondExistPopupSubtitle', {NUMBER: Object.keys(SCREENS).length - 1 - screen})}</Subtitle>
                    <Subtitle bigger={false}>{I18n.translate('firstExistPopupSubSubtitle')}</Subtitle>
                    <AboveCTAImage screen={screen} src={`${WP_CONTENT_PREFIX}/images/${screen === SCREENS.first ? 'Princess_in_distress.gif' : 'mouse_vs_cat.gif'}`} />
                    <CTAWrapper onClick={this.onCTAClick}>
                        <CTASide />
                            <CTAMiddle>
                                {I18n.translate(`${screen === SCREENS.first ? 'firstExitPopupCTA1' : 'secondExistPopupCTA1'}`)}
                            </CTAMiddle>
                        <CTASide />
                    </CTAWrapper>
                    <CenterHorizontalWrapper>
                        <LeftCTA href={TUTORIAL_VIDEO} onClick={this.onTutorialClick} target="_blank">{I18n.translate('exitPopupsCTA2')}</LeftCTA>
                        <RightCTA href={OPTION_PAGE} onClick={this.onSettingsClick} target="_blank">{I18n.translate('exitPopupsCTA3')}</RightCTA>
                    </CenterHorizontalWrapper>
                </Overlay>
            </Background>
        );
    }
}
